export default __webpack_public_path__ + "static/media/man.442d47f6.png";